// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:21818a34-2d9d-4734-adc4-ab2c45986a9b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_69u5jwYmj",
    "aws_user_pools_web_client_id": "7jv070t6lq96r5eg8uruhc3c8k",
    "oauth": {
        "domain": "labs12realestatefe3debf5fd-3debf5fd-dev.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://dq7s45dllbhyrl72br3azniqwu.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "labs12realestatefed5f9cdd26fd1410d8f0ec6404d30cb27-dev",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
